import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setHeaderTitle } from '../../redux/App/App.slice';

const StyledNotFoundPageTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
`;
const StyledNotFoundPageCode = styled.div`
  font-size: 350px;
  font-weight: 500;
  opacity: 0.05;
`;
const StyledNotFoundPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  min-height: 100%;
`;

const NotFoundPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(setHeaderTitle('Page not found'));
  }, [dispatch]);

  return (
    <StyledNotFoundPage>
      <StyledNotFoundPageCode>404</StyledNotFoundPageCode>
      <StyledNotFoundPageTitle>{t('Page not found')}</StyledNotFoundPageTitle>
    </StyledNotFoundPage>
  );
};

export default NotFoundPage;
